// Canonical Mixpanel event names for the teacher dashboard.
//
// Other call sites still use inline string literals today — migrating them is
// out of scope for this PR. New event names must be added here; string literals
// at new call sites are not acceptable.
export const MIXPANEL_EVENTS = {
  LOGOUT_INITIATED: "LOGOUT_INITIATED",
  STORY_SESSION_SELECTED: "STORY_SESSION_SELECTED",
  WORKSPACE_SELECTED: "WORKSPACE_SELECTED",
  RESOURCE_DOWNLOADED: "RESOURCE_DOWNLOADED",
  CHART_EXPANDED: "CHART_EXPANDED",
} as const;
